<template>
  <div class="vue-component-holder">
    <!--[if lt IE 8]>
    <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please
      <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.
    </p>
    <![endif]-->

    <!-- Page -->
    <div class="page vertical-align text-center" data-animsition-in="fade-in" data-animsition-out="fade-out">
      <div class="page-content vertical-align-middle animation-slide-top animation-duration-1">
        <div class="panel">
          <div class="panel-body">
            <div class="brand">
              <img class="brand-img" src="/static/assets/images/repnode-n-logo-colored.svg" alt="...">
            </div>

            <template v-if="submitted">
              <h1>{{ t('reg_lblThanks') }}</h1>
              <p>{{ t('reg_lblApplicationYour') }} <b>{{ formData.appName }}</b> {{ t('reg_lblApplicationCreated') }}</p>
              <p>{{ t('reg_lblApplicationCreatedInfo') }}</p>
              <a href="https://repnode.cz" class="btn btn-primary btn-block btn-lg mt-10">
                {{ t('reg_lblGoToRepnodeCZ') }}
              </a>
            </template>

            <template v-else>
              <h1>{{ t('reg_title') }}</h1>
              <form @submit.prevent="submit">
                <alert ref="alert" />

                <vue-recaptcha
                  ref="invisibleRecaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  size="invisible"
                  :sitekey="sitekey">
                </vue-recaptcha>

                <div class="form-group form-material floating" data-plugin="formMaterial">
                  <input v-model="formData.firstName" type="text"
                         class="form-control"
                         :class="{'is-invalid': errors.firstName}"
                         id="inputFirstName"
                         @keyup.enter="submit"/>
                  <div v-if="errors.firstName" class="invalid-feedback">{{ errors.firstName }}</div>
                  <label class="floating-label" for="inputFirstName">{{ t('reg_lblFirstName') }}</label>
                </div>

                <div class="form-group form-material floating" data-plugin="formMaterial">
                  <input v-model="formData.lastName" type="text"
                         class="form-control"
                         :class="{'is-invalid': errors.lastName}"
                         id="inputLastName"
                         @keyup.enter="submit"/>
                  <div v-if="errors.lastName" class="invalid-feedback">{{ errors.lastName }}</div>
                  <label class="floating-label" for="inputLastName">{{ t('reg_lblLastName') }}</label>
                </div>

                <div class="form-group form-material floating" data-plugin="formMaterial">
                  <input v-model="formData.companyName" type="text"
                         class="form-control"
                         :class="{'is-invalid': errors.companyName}"
                         id="companyName"
                         @keyup.enter="submit"/>
                  <div v-if="errors.companyName" class="invalid-feedback">{{ errors.companyName }}</div>
                  <label class="floating-label" for="inputAddress">{{ t('reg_lblCompanyName') }}</label>
                </div>

                <div class="form-group form-material floating" data-plugin="formMaterial">
                  <input v-model="formData.phone" type="text"
                         class="form-control"
                         :class="{'is-invalid': errors.phone}"
                         id="phone"
                         @keyup.enter="submit"
                         ref="phone"/>
                  <div v-if="errors.phone" class="invalid-feedback">{{ errors.phone }}</div>
                  <label class="floating-label" for="inputPhone">{{ t('reg_lblPhone') }}</label>
                </div>

                <div class="form-group form-material floating" data-plugin="formMaterial">
                  <input v-model="formData.email" type="text"
                         class="form-control"
                         :class="{'is-invalid': errors.email}"
                         id="inputEmail"
                         @keyup.enter="submit"/>
                  <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
                  <label class="floating-label" for="inputEmail">{{ t('reg_lblEmail') }}</label>
                </div>

                <div class="form-group form-material floating" data-plugin="formMaterial">
                  <input v-model="formData.appName" type="text"
                         class="form-control"
                         :class="{'is-invalid': errors.appName}"
                         id="inputAppName"
                         @keyup.enter="submit"/>
                  <div v-if="errors.appName" class="invalid-feedback">{{ errors.appName }}</div>
                  <label class="floating-label" for="inputAppName">{{ t('reg_lblAppName') }}</label>
                  <small>http://app.repnode.com/{{ formData.appName }}</small>
                </div>

                <vue-recaptcha
                  ref="invisibleRecaptchaAppName"
                  @verify="onVerifyAppName"
                  @expired="onExpiredAppName"
                  size="invisible"
                  :sitekey="sitekey">
                </vue-recaptcha>

                <button
                  @click="submit"
                  :disabled="!submitable || loading"
                  type="button"
                  class="btn btn-primary btn-block btn-lg mt-40">
                  {{ loading ? 'Odesílám...' : t('reg_lblSubmit') }}
                </button>
              </form>
            </template>
          </div>
        </div>

        <footer class="page-copyright page-copyright-inverse">
          <p>© {{ new Date().getFullYear() }}. All RIGHT RESERVED.</p>
        </footer>
      </div>
    </div>
    <!-- End Page -->
  </div>
</template>

<script>
import alert from '../alert'
import DependencyLoader from '../../../model/loader/user-base-entities-loader'
import { http } from '@/http'
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    'vue-recaptcha': VueRecaptcha,
    'alert': alert
  },
  data () {
    return {
      translatesLoaded: false,
      submitted: false,
      loading: false,
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        phone: '',
        appName: ''
      },
      errors: {
        firstName: null,
        lastName: null,
        email: null,
        companyName: null,
        phone: null,
        appName: null
      },
      submitable: false,
      sitekey: '6Lfs1hYbAAAAABJtSdx_iAem6KshfEY8LEiEHtvP'
    }
  },
  created () {
    DependencyLoader.reset()
    this.initTranslates()
    document.body.classList.add('animsition', 'page-login-v3', 'layout-full')
    document.body.classList.remove('dashboard')
  },
  mounted () {
    const phoneElement = $(this.$refs.phone)
    phoneElement.inputmask('+999 999 999 999', {
      oncomplete: () => {
        this.formData.phone = phoneElement.val()
        this.errors.phone = null
      },
      onincomplete: () => {
        this.formData.phone = null
        phoneElement.val(null)
        this.errors.phone = 'telefon ve formátu +420 123 456 789'
      }
    })
  },
  watch: {
    'formData.firstName' () { this.validateLength('firstName') },
    'formData.lastName' () { this.validateLength('lastName') },
    'formData.companyName' () { this.validateLength('companyName') },
    'formData.email' () { this.validateEmail('email') },
    'formData.appName' () {
      this.validateLength('appName')
      if (!this.errors.appName) {
        this.$refs.invisibleRecaptchaAppName.execute()
      }
    },
    'formData': {
      handler () {
        this.submitable = !this.hasErrors()
      },
      deep: true
    }
  },
  methods: {
    submit () {
      this.$refs.invisibleRecaptcha.execute()
    },
    async onVerify (token) {
      this.loading = true
      try {
        const response = await http.post('Registration/CreateApp', {
          FirstName: this.formData.firstName,
          LastName: this.formData.lastName,
          Company: this.formData.companyName,
          AddressName: null,
          Phone: this.formData.phone,
          Email: this.formData.email,
          AppName: this.formData.appName,
          'g-recaptcha-response': token
        })

        if (response.status >= 200 && response.status < 300) {
          this.submitted = true
          this.$refs.alert.show('Úspěch', 'Aplikace byla úspěšně vytvořena.', 'success')
        } else {
          this.handleApiError(response)
        }
      } catch (e) {
        console.error(e)
        this.$refs.alert.show('Chyba', 'Nepodařilo se odeslat formulář.', 'danger')
      } finally {
        this.loading = false
      }
    },
    onExpired () {
      console.log('Recaptcha Expired')
    },
    async onVerifyAppName (token) {
      try {
        this.errors.appName = null
        await http.post('Registration/VerifyApp', {
          AppName: this.formData.appName,
          'g-recaptcha-response': token
        })
        this.submitable = !this.hasErrors()
      } catch (e) {
        if (e.response) {
          this.errors.appName = e.response.data
        }
        this.submitable = !this.hasErrors()
      }
    },
    onExpiredAppName () {
      console.log('Recaptcha AppName Expired')
    },
    hasErrors () {
      return Object.keys(this.errors).some(key => this.errors[key]) ||
             Object.values(this.formData).some(v => !v)
    },
    validateLength (field) {
      const value = this.formData[field] || ''
      if (value.length < 3 || value.length > 60) {
        this.errors[field] = 'minimální délka je 3 znaky, maximální délka 60 znaků'
      } else {
        this.errors[field] = null
      }
    },
    validateEmail (field) {
      if (!this.emailIsValid(this.formData[field])) {
        this.errors[field] = 'email není validní'
      } else {
        this.errors[field] = null
      }
    },
    emailIsValid (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },
    initTranslates () {
      if (this.translatesLoaded) return
      this.$translate.setLocales({
        cs: {
          reg_title: 'Založení aplikace',
          reg_lblFirstName: 'Jméno',
          reg_lblLastName: 'Příjmení',
          reg_lblEmail: 'Email',
          reg_lblAppName: 'Název aplikace',
          reg_lblCompanyName: 'Název firmy',
          reg_lblPhone: 'Telefon',
          reg_lblSubmit: 'Založit',
          reg_lblThanks: 'Děkujeme',
          reg_lblApplicationYour: 'Vaše aplikace',
          reg_lblApplicationCreated: 'byla vytvořena',
          reg_lblApplicationCreatedInfo: 'Dále pokračujte dle informací zaslaných na email uvedený v registraci',
          reg_lblGoToRepnodeCZ: 'Přejít na repnode.cz'
        }
      })
      this.$translate.setLang('cs')
      this.translatesLoaded = true
    }
  }
}
</script>

<style scoped>
.page-login-v3 .panel {
  width: 100%;
}
@media (max-width: 500px) {
  h1, .h1 {
    font-size: 2.272rem!important;
  }
}
@media (min-width: 768px) {
  .page-login-v3 .panel { width: 400px; }
}
@media (min-width: 992px) {
  .page-login-v3 .panel { width: 600px; }
}
.page-login-v3 .brand-img {
  width: 60%;
}
.consent, .consent a { margin: 0; }
@media (max-width: 600px) {
  .page-login-v3 .panel { width: 100%; }
}
</style>
